<template>
<simple-modal id="login-modal" class="fade">
  <slot name="caption">ログイン有効期限が切れました。お手数ですが再度ログインしてください。</slot>
  <div class="form-group">
    <label for="userID" class="sr-only">ユーザー名（メールアドレス）</label>
    <input type="mail" class="form-control" placeholder="ユーザー名（メールアドレス）" v-model="credencials.email">
  </div>
  <div class="form-group mb-5">
    <label for="pass" class="sr-only">パスワード</label>
    <input type="password" class="form-control" placeholder="パスワード" v-model="credencials.password">
  </div>
  <p>{{ message }}</p>
  <button type="button" style="display:none;" data-dismiss="modal" ref="dismissBtn"/>
  <button slot="footer" class="btn btn-primary" type="button" @click="submit()" :class="loginButtonStyle">ログイン</button>
</simple-modal>
</template>

<script>
import SimpleModal from 'components/SimpleModal'
import auth from '../../auth'
import util from 'util/lecturer'
import $ from 'jquery'
export default {
  components: {
    SimpleModal
  },

  data () {
    return {
      credencials: {
        email: '',
        password: ''
      },
      message: '',
      loginProceeding: false,
      error: ''
    }
  },

  methods: {
    submit () {
      if (!this.isCredencialsValid) return

      var cred = { ...this.credencials }
      this.message = 'ログインしています…'
      this.loginProceeding = true
      auth.login(this, cred)
      .then(_ => {
        this.message = 'ログインしました'
        setTimeout(() => {
          this.$refs.dismissBtn.click()
          this.credencials.email = ''
          this.credencials.password = ''
          this.message = ''
          this.loginProceeding = false
          this.error = ''
        }, 1000 /* [ms] */)
      }).catch(err => {
        this.error = err
        this.message = 'ログインに失敗しました'
        this.loginProceeding = false
      })
    },
    showModal () {
      $('#login-modal').modal()
    }
  },

  computed: {
    isCredencialsValid () {
      return util.validateEmail(this.credencials.email) && this.credencials.password
    },
    loginButtonStyle () {
      return this.isCredencialsValid && !this.loginProceeding ? '' : 'disabled'
    }
  }
}
</script>



// WEBPACK FOOTER //
// LoginModal.vue?ec876b88